import request from '@/api/request'
/**
 * 获取所有用途和产品
 */
export function bidUseProductionApi () {
  return request({
    url: '/online/bid_use_production',
    method: 'get'
  })
}

/**
 * 获取所有事项
 */
export function bidNotaryApi () {
  return request({
    url: '/online/bid_notary',
    method: 'get'
  })
}

/**
 * 获取申办说明
 */
export function bidDetailApi (query) {
  return request({
    url: '/online/detail',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/online/index.js